/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/



export const columns: TableColumn[] = [
    {
      Header: 'tableCommon.sl_no',
      accessor: 'slno',
    },
    {
      Header: 'areaManagement.tableColumns.area_code',
      accessor: 'area_code',
    },
    {
      Header: 'areaManagement.tableColumns.area_name',
      accessor: 'name',
    },
    {
      Header: 'tableCommon.area_type',
      accessor: 'type',
    },
  ];

  //table columns for location management table section 
  export const locationColumns: TableColumn[] = [
    {
      Header: 'tableCommon.sl_no',
      accessor: 'slno',
    },
    {
      Header: 'locationManagement.tableColumns.location_code',
      accessor: 'area_code',
    },
    {
      Header: 'tableCommon.location_name',
      accessor: 'name',
    },
    {
      Header: 'scheduleProduction.tableColumns.area_name',
      accessor: 'area_name',
    },
    {
      Header: 'tableCommon.location_type',
      accessor: 'type',
    },
  ];
  
  interface TableColumn {
    Header: string;
    accessor: string;
  }
  